/**
 * @param {string} message
 * @returns {boolean} true when navigation may proceed
 */
export function confirmUnsavedNavigation(message) {
  if (typeof window === "undefined" || typeof window.confirm !== "function") {
    return true;
  }
  return window.confirm(message);
}
